import routePaths from 'const/routePaths'
import { PageEvent } from 'syf-js-utilities/typings/analytics'

const acccountManagement = 'account management'

const helpCenter = 'help center'
const login = 'login'

export const PAGE_EVENTS: { [key: string]: PageEvent } = {
  [routePaths.home]: {
    PAGE_KIND: login,
    PAGE_FUNCTION: login,
    PAGE_NAME: 'start',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.summary]: {
    PAGE_KIND: 'accountsummary',
    PAGE_FUNCTION: 'accountsummary',
    PAGE_NAME: 'view',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.makePayment]: {
    PAGE_KIND: 'payments',
    PAGE_FUNCTION: 'makeapayment',
    PAGE_NAME: 'start',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.viewPayment]: {
    PAGE_KIND: 'payments',
    PAGE_FUNCTION: 'viewpayments',
    PAGE_NAME: 'start',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.invoice]: {
    PAGE_KIND: 'billing',
    PAGE_FUNCTION: 'invoices',
    PAGE_NAME: 'start',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.statement]: {
    PAGE_KIND: 'billing',
    PAGE_FUNCTION: 'estatement enrolled',
    PAGE_NAME: 'start',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.transactions]: {
    PAGE_KIND: 'billing',
    PAGE_FUNCTION: 'transactions',
    PAGE_NAME: 'start',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.credit]: {
    PAGE_KIND: 'billing',
    PAGE_FUNCTION: 'credits',
    PAGE_NAME: 'view',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.companyProfile]: {
    PAGE_KIND: 'accountmanagement',
    PAGE_FUNCTION: 'companyprofile',
    PAGE_NAME: 'start',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.managePayment]: {
    PAGE_KIND: acccountManagement,
    PAGE_FUNCTION: 'manage payment account',
    PAGE_NAME: 'view',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.manageBuyers]: {
    PAGE_KIND: acccountManagement,
    PAGE_FUNCTION: 'manage authorized buyers',
    PAGE_NAME: 'view',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.manageUser]: {
    PAGE_KIND: acccountManagement,
    PAGE_FUNCTION: 'manage users',
    PAGE_NAME: 'view',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.manageLinkedAccounts]: {
    PAGE_KIND: acccountManagement,
    PAGE_FUNCTION: 'manage linked accounts',
    PAGE_NAME: 'view',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.manageChildAccount]: {
    PAGE_KIND: acccountManagement,
    PAGE_FUNCTION: 'manage child account',
    PAGE_NAME: 'start',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.emailStatement]: {
    PAGE_KIND: 'account management',
    PAGE_FUNCTION: 'enroll estatements',
    PAGE_NAME: 'start',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.increaseCreditLine]: {
    PAGE_KIND: acccountManagement,
    PAGE_FUNCTION: 'request credit line increase',
    PAGE_NAME: 'start',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.taxForms]: {
    PAGE_KIND: acccountManagement,
    PAGE_FUNCTION: 'download tax forms',
    PAGE_NAME: 'view',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.editJobName]: {
    PAGE_KIND: acccountManagement,
    PAGE_FUNCTION: 'batch edit job name',
    PAGE_NAME: 'start',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.closeAccount]: {
    PAGE_KIND: acccountManagement,
    PAGE_FUNCTION: 'close account',
    PAGE_NAME: 'view',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.userGuide]: {
    PAGE_KIND: helpCenter,
    PAGE_FUNCTION: 'user guide',
    PAGE_NAME: 'view',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.contactUs]: {
    PAGE_KIND: helpCenter,
    PAGE_FUNCTION: 'contact us',
    PAGE_NAME: 'view',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.recoverUserId]: {
    PAGE_KIND: login,
    PAGE_FUNCTION: 'recover user id',
    PAGE_NAME: 'start',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.resetPassword]: {
    PAGE_KIND: login,
    PAGE_FUNCTION: 'reset password',
    PAGE_NAME: 'account info step',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.updatePassword]: {
    PAGE_KIND: login,
    PAGE_FUNCTION: 'update password',
    PAGE_NAME: 'update password',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.invoiceBillPay]: {
    PAGE_KIND: acccountManagement,
    PAGE_FUNCTION: 'INT enroll',
    PAGE_NAME: 'view',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.ibpStatus]: {
    PAGE_KIND: acccountManagement,
    PAGE_FUNCTION: 'INT enroll',
    PAGE_NAME: 'pending',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.videoGallery]: {
    PAGE_KIND: helpCenter,
    PAGE_FUNCTION: 'videogallery',
    PAGE_NAME: 'start',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.editBusinessInfo]: {
    PAGE_KIND: acccountManagement,
    PAGE_FUNCTION: 'edit business information',
    PAGE_NAME: 'start',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.editUser]: {
    PAGE_KIND: acccountManagement,
    PAGE_FUNCTION: 'edit user information',
    PAGE_NAME: 'view',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.registration]: {
    PAGE_KIND: 'registration',
    PAGE_FUNCTION: 'authentication',
    PAGE_NAME: 'default',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.registerChildAccount]: {
    PAGE_KIND: 'registration',
    PAGE_FUNCTION: 'register child account',
    PAGE_NAME: 'start',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.requestBuyerCards]: {
    PAGE_KIND: acccountManagement,
    PAGE_FUNCTION: 'request additional buyer cards',
    PAGE_NAME: 'view',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.error]: {
    PAGE_KIND: 'error',
    PAGE_FUNCTION: 'error',
    PAGE_NAME: 'system error',
    PAGE_SUB_FUNCTION: ''
  },
  // We might need to change this. Added in the meantime to avoid the application from crashing
  [routePaths.sessionExpired]: {
    PAGE_KIND: 'sessionexpired',
    PAGE_FUNCTION: 'sessionexpired',
    PAGE_NAME: 'system sessionexpired',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.logout]: {
    PAGE_KIND: login,
    PAGE_FUNCTION: 'logout',
    PAGE_NAME: 'complete',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.lostCard]: {
    PAGE_KIND: acccountManagement,
    PAGE_FUNCTION: 'report lost/stolen card',
    PAGE_NAME: 'view',
    PAGE_SUB_FUNCTION: ''
  },
  [routePaths.lostCardConfirmation]: {
    PAGE_KIND: acccountManagement,
    PAGE_FUNCTION: 'lost or stolen card confirmation',
    PAGE_NAME: 'view',
    PAGE_SUB_FUNCTION: ''
  }
}

export const BRC_PAGE_EVENTS: { [key: string]: Partial<PageEvent> } = {
  [routePaths.makePayment]: {
    PAGE_KIND: 'payments',
    PAGE_FUNCTION: 'makeapayment',
    PAGE_NAME: 'select payment type'
  },
  [routePaths.closeAccount]: {
    PAGE_KIND: acccountManagement,
    PAGE_FUNCTION: 'close account',
    PAGE_NAME: 'start'
  },
  [routePaths.viewPayment]: {
    PAGE_KIND: 'payments',
    PAGE_FUNCTION: 'payment history',
    PAGE_NAME: 'view'
  }
}

export const DEVICE = {
  DESK: 'desk',
  MOBI: 'mobile',
  TAB: 'tab'
}

export const setPageAnalytics = (pathName: string | number): void => {
  if (PAGE_EVENTS[pathName]) {
    PAGE_EVENTS[pathName].PAGE_KIND =
      BRC_PAGE_EVENTS[pathName]?.PAGE_KIND || PAGE_EVENTS[pathName].PAGE_KIND
    PAGE_EVENTS[pathName].PAGE_FUNCTION =
      BRC_PAGE_EVENTS[pathName]?.PAGE_FUNCTION ||
      PAGE_EVENTS[pathName].PAGE_FUNCTION
    PAGE_EVENTS[pathName].PAGE_NAME =
      BRC_PAGE_EVENTS[pathName]?.PAGE_NAME || PAGE_EVENTS[pathName].PAGE_NAME
  }
}
